import * as React from 'react';
import { RouteComponentProps } from 'react-router-dom';
import CheckBox from 'src/components/shared/CheckBox';

import Workflow from 'src/models/workflow';
import { RegistrationStep } from '../../utils/constValues';
import { getCurrentStepRouter } from 'src/utils/workflow';
import { AgreeTermsRequest } from 'src/models/agreeTerms';
import * as api from '../../api/uploadFile';

export interface StateFromProps {
    registrationId: string;
    sessionId: string;
    workflow: Workflow;

    submitting: boolean;
    submitted: boolean;
    termsAgreed: boolean;
}

export interface DispatchFromProps {
    submitAgreeTerms: (agreeTerms: AgreeTermsRequest) => void;
}

export type OwnProps = RouteComponentProps<{}>;

type Props = StateFromProps & DispatchFromProps & OwnProps;

export interface State {
    hasError: boolean;
    triggerCheckError: boolean;
    isAgree: boolean;
    agreement: string;
}

class ContractAgreement extends React.Component<Props, State> {
    constructor(props: Props) {
        super(props);
        window.document.title = 'Agreement';

        this.state = this.state = this.getInitialState();
    }

    getInitialState = (): State => {
        return {
            hasError: false,
            triggerCheckError: false,
            isAgree: false,
            agreement: ''
        };
    }

    componentDidMount() {
        api.agreementFile()
            .then((response: string) => {
                if (response != undefined && response !== '') {
                    this.setState({ agreement: response });
                }
            });
    }

    componentWillReceiveProps(nextProps: Props) {
        if (nextProps.submitted && nextProps.termsAgreed
            && nextProps.workflow.isCurrentStepFinished
            && nextProps.workflow.currentStep === RegistrationStep.PaymentInformation) {
            this.props.history.push(getCurrentStepRouter(nextProps.workflow));
        }
    }

    changeRadioBox = (field: string) => {
        this.setState({ isAgree: !this.state.isAgree });
    }

    submitAgreeTerms = (): void => {
        const { registrationId } = this.props;
        const { hasError, triggerCheckError, isAgree } = this.state;
        if (!hasError && isAgree) {
            let agreeTerms: AgreeTermsRequest = {
                registrationId: registrationId,
                // sessionId: sessionId,
                termsAgreed: isAgree
            };
            this.props.submitAgreeTerms(agreeTerms);
        } else {
            this.setState({ triggerCheckError: !triggerCheckError });
        }
    }

    render() {
        const { submitting } = this.props;
        const { isAgree } = this.state;
        return (
            <main>
                <div className="tab-content tabs-style">
                    <div className="tab-pane h-100 fade show active" id="" role="tabpanel">
                        <div className="flex-full">
                            <div className="fix-workspace flex-full">
                                <div className="tab-content wrapper-lv-4">
                                    <div className="tab-pane h-100 fade show active" role="tabpanel">
                                        <div className="row no-gutters pl-1 pr-1 h-100">
                                            <div className="col main-cont">
                                                <div className="flex-full card-sp">
                                                    <h5 className="card-title-sp">License Agreement Documents</h5>
                                                    <div className="card-cont-sp flex-full">
                                                        <div className="fix-workspace agreement-area">
                                                            {
                                                                submitting || this.state.agreement === '' ?
                                                                    <div className="loading-center">
                                                                        <table className="table table-borderless">
                                                                            <tbody className="spinner-bg d-flex">
                                                                                <tr className="text-center">
                                                                                    <td className="alert alert-info" role="alert">
                                                                                        <span className="alert-text"><span className="spinner-border text-info spinner-border-md float-right" role="status" aria-hidden="true" />{submitting ? 'Submitting...' : 'Loading...'}</span>
                                                                                    </td>
                                                                                </tr>
                                                                            </tbody>
                                                                        </table>
                                                                    </div>
                                                                    :
                                                                    <>
                                                                        <textarea id="txtAgreement" name="agreement" readOnly={true} defaultValue={this.state.agreement} />
                                                                        <div className="col-auto form-group" style={{ marginTop: '15px' }}>
                                                                            <CheckBox
                                                                                id="cbAgreed"
                                                                                checked={isAgree}
                                                                                value={``}
                                                                                onChange={this.changeRadioBox}
                                                                                field="agree"
                                                                                isCheckbox={true}
                                                                                label="Agreed"
                                                                                extendClass="custom-control-inline"
                                                                                disabled={this.state.agreement === ''}
                                                                            />
                                                                        </div>
                                                                    </>
                                                            }
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                                <div className="main-btn-group d-flex align-items-center">
                                    <button className="btn btn-sm btn-light" type="submit" disabled={!isAgree || submitting} onClick={this.submitAgreeTerms}><i className="fa fa-arrow-right" /> Next</button>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </main>
        );
    }
}

export default ContractAgreement;


// WEBPACK FOOTER //
// ./src/components/ContractAgreement/ContractAgreement.tsx